import { render } from "./RegBus.vue?vue&type=template&id=c7525194"
import script from "./RegBus.vue?vue&type=script&lang=js"
export * from "./RegBus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__